import { render, staticRenderFns } from "./cStar.vue?vue&type=template&id=078511aa&scoped=true"
import script from "./cStar.vue?vue&type=script&lang=js"
export * from "./cStar.vue?vue&type=script&lang=js"
import style0 from "./cStar.vue?vue&type=style&index=0&id=078511aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078511aa",
  null
  
)

export default component.exports